import { widget } from "@foretagsplatsen/widgetjs";
import ArrayStream from "../../../core/list/streams/ArrayStream.js";
import ListSource from "../../../core/list/ListSource.js";
import ListSourceWidget from "../../../core/widgets/list/ListSourceWidget/ListSourceWidget.js";

/**
 * `abstractPeriodReportArchiveSectionWidget` is an abstract report section.
 * The purpose of a section is to render a list of periodReport instances.
 *
 * It is delegated to the subclasses to know how.
 *
 * @param {*} spec - Parameter object
 * @param {string} [spec.title] - Section title
 * @param {periodReport[]} [spec.items] - periodReport instances to render
 * @param {function} spec.selectionPredicate - function used to determinate if the provided report is currently selected
 * @param {*} my - protected fields holder
 * @return {{}}
 */
function abstractPeriodReportArchiveSectionWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	my.title = spec.title || "";
	my.items = spec.items || [];

	my.selectionPredicate =
		spec.selectionPredicate ||
		function () {
			return false;
		};

	that.onSelect = my.events.createEvent();
	that.onResetSelection = my.events.createEvent();

	my.grid = null;

	that.renderContentOn = function (html) {
		const div = html.div(
			{ class: "reports-block-segment" },
			html.div({ class: "panel-title" }, html.h4(my.title)),
			html.div({ class: "container" }, my.getGrid()),
		);

		my.addHooks(div);
	};

	my.getGrid = function () {
		if (!my.grid) {
			const strategy = new (my.getGridClass())({
				...my.getExtraOptions(),
			});

			const source = ListSource.makeAndFetch({
				stream: new ArrayStream({
					data: sortReports(my.items),
				}),
			});

			my.grid = new ListSourceWidget({ strategy, source });
		}

		return my.grid;
	};

	my.getGridClass = function () {
		throw new Error("Subclass responsibility");
	};

	my.addHooks = function () {};

	my.getExtraOptions = function () {
		return {};
	};

	function sortReports(reports) {
		return reports.sort((a, b) => {
			if (a.isWithdrawn() && !b.isWithdrawn()) {
				return 1;
			}
			return a.isPublishedBefore(b) ? -1 : 1;
		});
	}

	return that;
}

export default abstractPeriodReportArchiveSectionWidget;
